<section class="international-sms-page">
    <div class="banner small">
      <div class="container">
        <div class="row">
          <div class="ten offset-one">
            <div class="banner-main-content text-center">
              <h1>International SMS<br>Country List</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="banner-fill subtle"></div>
    </div>
  
    <section class="international-calling-details">
      <div class="container-flex">
        <div class="countries">
          <h3>International SMS Country List:</h3>
          <ul class="sort-nav">
            <li *ngFor="let letter of letters" value="{{letter}}" [class.active]="selected == letter"><a
                (click)="filterCountries(letter);selected=letter">{{letter}}</a></li>
          </ul>
        </div>
      </div>
    </section>
  
    <section class="ild-table">
      <div class="container">
        <div class="row">
          <div class="twelve">
            <div *ngIf="filteredCountries?.length == 0">
              <p class="no-countries">No countries found</p>
            </div>
            <table class="table" *ngIf="filteredCountries?.length > 0">
              <thead>
                <tr>
                  <th class="width">Country</th>
                  <th>Country Code</th>
                  <th>Dialing Pattern</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let country of filteredCountries">
                  <td>{{country?.fields?.country}}</td>
                  <td>{{country?.fields?.countryCode}}</td>
                  <td>{{country?.fields?.dialingPattern}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </section>